import { Navigate, Outlet } from 'react-router-dom'
import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'
import { useAuthContext } from '../../../state/useAuth'
import { ROUTES } from '../../../constants/routes'
import Spinner from '../../shared/Spinner'

const LoaderStyled = styled.div`
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PublicRoutesGuard: FC<PropsWithChildren> = ({ children }) => {
  const { authData, isAuthInitialized } = useAuthContext()
  const isAuthenticated = authData?.access_token

  if (!isAuthInitialized) {
    return (
      <LoaderStyled>
        <Spinner widthHeight={42} />
      </LoaderStyled>
    )
  }

  if (isAuthenticated) {
    return <Navigate to={authData?.userRole === 'admin' ? ROUTES.ADMIN_PANEL : ROUTES.DATASETS} replace />
  }

  return (
    children
      ? <>{children}</>
      : <Outlet />
  )
}

export default PublicRoutesGuard
